import React from 'react';
import { TrendingUp, TrendingDown, Minus } from 'lucide-react';

const StatCard = ({ title, value, change, changeType, icon, isLoading }) => {
  if (isLoading) {
    return (
      <div className="bg-white rounded-lg shadow-sm border p-6 animate-pulse">
        <div className="flex items-center justify-between">
          <div className="flex-1">
            <div className="h-4 bg-gray-200 rounded w-20 mb-2"></div>
            <div className="h-8 bg-gray-200 rounded w-16"></div>
          </div>
          <div className="h-12 w-12 bg-gray-200 rounded-lg"></div>
        </div>
        <div className="mt-4 h-3 bg-gray-200 rounded w-24"></div>
      </div>
    );
  }

  const getChangeColor = () => {
    if (changeType === 'positive') return 'text-green-600';
    if (changeType === 'negative') return 'text-red-600';
    return 'text-gray-600';
  };

  const getChangeIcon = () => {
    if (changeType === 'positive') return <TrendingUp className="w-4 h-4" />;
    if (changeType === 'negative') return <TrendingDown className="w-4 h-4" />;
    return <Minus className="w-4 h-4" />;
  };

  return (
    <div className="bg-white rounded-lg shadow-sm border p-6 hover:shadow-md transition-shadow">
      <div className="flex items-center justify-between">
        <div className="flex-1">
          <p className="text-sm font-medium text-gray-600 mb-1">{title}</p>
          <p className="text-2xl font-bold text-gray-900">{value}</p>
        </div>
        {icon && (
          <div className="flex-shrink-0 p-3 bg-blue-50 rounded-lg">
            {typeof icon === 'string' ? (
              <span className="text-2xl">{icon}</span>
            ) : (
            <div className="w-6 h-6 text-blue-600">{icon}</div>
            )}
          </div>
        )}
      </div>
      {change && (
        <div className="mt-4 flex items-center space-x-1 rtl:space-x-reverse">
          <span className={`text-sm font-medium flex items-center space-x-1 rtl:space-x-reverse ${getChangeColor()}`}>
            {getChangeIcon()}
            <span>{change}</span>
          </span>
        </div>
      )}
    </div>
  );
};

export default StatCard;
